import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

// Sentry OPCIONAL: solo con VITE_SENTRY_DSN (se incrusta en el build); sin DSN no hace nada. Scrubbing por lista blanca.
// Import dinámico: sin DSN el SDK ni siquiera se descarga.
const sentryDsn: string | undefined = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  void import('@coreai/observability/browser').then((m) =>
    m.initSentryBrowser({ dsn: sentryDsn, environment: import.meta.env.MODE }),
  );
}

const root = document.getElementById('root');
if (!root) throw new Error('#root no encontrado');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
